import { render } from "./ObligationsView.vue?vue&type=template&id=2c3ed349&scoped=true"
import script from "./ObligationsView.vue?vue&type=script&lang=js"
export * from "./ObligationsView.vue?vue&type=script&lang=js"

import "./ObligationsView.vue?vue&type=style&index=0&id=2c3ed349&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3ed349"]])

export default __exports__